<template>
  <transition name="fade">
    <div>
      <div class="pop-up-bg" @click.prevent="$emit('closeContact', false)"></div>
      <div class="pop-up pop-up--delete">
        <a class="pop-up__close icon icon-close" @click.prevent="$emit('closeContact', false)"></a>
        <h2 v-if="!deleteContact">{{$root.langText.contacts.changeContacts}}</h2>
        <h2 v-else>{{$root.langText.contacts.deleteContacts}}</h2>
        <div v-if="!deleteContact">
          <Autocomplete 
            :hidden="hidden"
            :data="{
              name: $root.langText.contacts.contactPerson, 
              mod: 'contact', 
              key: 'contact', 
              input: contact, 
              inputId: contact_id, 
              idClient: id, 
              typeClient: mod
            }" 
            @result="autocompleteResult" 
          />

          <Contact :hidden="hidden" :data="data" @change="changeInput"/>
          <p style="font-size: 13px; color:#EB5757;margin-bottom: 15px;text-align:center" v-if="error">{{$root.langText.changes.checkData}}</p>
          <div class="pop-up__btn block-btn--color">
            <a class="btn btn-primary" @click.prevent="warningDelete">{{$root.langText.delete}}</a>
            <a class="btn btn-primary" @click.prevent="saveContact">{{$root.langText.save}}</a>
          </div>
        </div>
        <div v-else>
          <div class="img warning"></div>
          <h3>{{$root.langText.contacts.isDelete}}</h3>
          <div class="pop-up__btn block-btn--color">
            <a class="btn btn-primary" @click.prevent="deleteContact2">{{$root.langText.delete}}</a>
            <a class="btn btn-primary" @click.prevent="warningDelete">{{$root.langText.save}}</a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<style lang="scss">
  .warning{
    background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 511.999 511.999' style='enable-background:new 0 0 511.999 511.999;' xml:space='preserve'%3E%3Cpath style='fill:%23E50027;' d='M501.449,368.914L320.566,66.207C306.751,43.384,282.728,29.569,256,29.569 s-50.752,13.815-64.567,36.638L10.55,368.914c-13.812,23.725-14.113,51.954-0.599,75.678c13.513,23.723,37.836,37.838,65.165,37.838 h361.766c27.329,0,51.653-14.115,65.165-37.838C515.563,420.868,515.262,392.639,501.449,368.914z'/%3E%3Cpath style='fill:%23C1001F;' d='M502.049,444.592c-13.513,23.723-37.836,37.838-65.165,37.838H256V29.57 c26.727,0,50.752,13.815,64.567,36.638L501.45,368.915C515.262,392.639,515.563,420.868,502.049,444.592z'/%3E%3Cpath style='fill:%23FD003A;' d='M75.109,452.4c-16.628,0-30.851-8.27-39.063-22.669c-8.211-14.414-8.065-31.087,0.469-45.72 L217.23,81.549c8.27-13.666,22.816-21.951,38.769-21.951s30.5,8.284,38.887,22.157l180.745,302.49 c8.388,14.4,8.534,31.072,0.322,45.485c-8.211,14.4-22.435,22.669-39.063,22.669H75.109V452.4z'/%3E%3Cpath style='fill:%23E50027;' d='M436.891,452.4c16.628,0,30.851-8.27,39.063-22.669c8.211-14.414,8.065-31.087-0.322-45.485 L294.886,81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4H436.891z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03s-30.031-13.514-30.031-30.03V152.095 c0-16.517,13.514-30.031,30.031-30.031S286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M286.03,152.095v120.122c0,16.517-13.514,30.03-30.03,30.03V122.064 C272.516,122.064,286.03,135.578,286.03,152.095z'/%3E%3Cpath style='fill:%23E1E4FB;' d='M256,332.278c-24.926,0-45.046,20.119-45.046,45.046c0,24.924,20.119,45.046,45.046,45.046 s45.046-20.121,45.046-45.046C301.046,352.398,280.925,332.278,256,332.278z'/%3E%3Cpath style='fill:%23C5C9F7;' d='M301.046,377.323c0,24.924-20.119,45.046-45.046,45.046v-90.091 C280.925,332.278,301.046,352.398,301.046,377.323z'/%3E%3C/svg%3E%0A");
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
  }
  .pop-up--delete h3 span{
    text-transform: uppercase;
  }
</style>


<script>
import Autocomplete from "@/components/app/Autocomplete"
import Contact from "@/components/contacts/Contact"


export default {
  props: ['data', 'dataAll', 'id', 'mod', 'modOne', 'hidden'],

  data:() => ({
    contact: '',
    contact_id: '',
    input: '',
    typeContact: '',
    deleteContact: false,
    error: false

  }),

  created() {
    if(!this.modOne){
      this.contact = this.dataAll.name
      this.contact_id = this.dataAll.id
    }
  },


  methods: {
    //autocomplete
    autocompleteResult(data){
      this[data.input] = data.name
      this[data.input + '_id'] = data.id
    },

    changeInput(data){
      this.input = data.value
      this.typeContact = data.type
    },


    warningDelete(){
      this.deleteContact = !this.deleteContact
    },
    async deleteContact2(){
      await this.$store.dispatch('deleteContacts', this.data.contact_id)
      this.$emit('closeContact')
    },

    async saveContact(){
      var data = {
        type: +this.typeContact,
        value: this.input,
        client_id: this.id
      }




      if(this.contact_id == undefined){
        data.id = this.data.contact_id
        var res = await this.$store.dispatch('updateContacts', data)
        if(res.data.status == 'error'){
          this.error = true
        } else{
          this.error = false
          this.$emit('closeContact')
        }
      } else if(!this.modOne && this.contact_id == this.dataAll.id){
        data.id = this.data.contact_id
        data.person_id = this.contact_id
        data.owner_type = this.mod
        var res = await this.$store.dispatch('updateContacts', data)
        if(res.data.status == 'error'){
          this.error = true
        } else{
          this.error = false
          this.$emit('closeContact')
        }
      } else{
        data.id = this.data.contact_id
        data.person_id = this.contact_id
        data.owner_type = this.mod
        var res = await this.$store.dispatch('updateContacts', data)
        if(res.data.status == 'error'){
          this.error = true
        } else{
          this.error = false
          this.$emit('closeContact')
        }
      }
    }
  },


  components:{
    Autocomplete: () => import('@/components/app/Autocomplete.vue'), Contact
  }
}
</script>